import { dcpcApi } from './dcpcApi';
import { DATASOURECES_INVALIDATE_TAG } from './datasourcesApi';
import { DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG } from './datasourceProgramBlocksApi';
import { DEVICE_TYPES_TAG } from './deviceTypeApi';
import { tags } from './tags';

export const DEVICES_INVALIDATE_TAG = 'DEVICES';

const {
  CREATE_PROGRAM_BLOCK_TAG,
  DELETE_PROGRAM_BLOCK_TAG,
  DATASOURCE_PROGRAM_TAG,
  DELETE_DATASOURCE_PROGRAM_TAG,
  CREATE_DATASOURCE_PROGRAM_TAG,
  CREATE_DATASOURCE_PROGRAM_BLOCK_TAG,
  DELETE_DATASOURCE_PROGRAM_BLOCK_TAG,
  DELETE_PROGRAM_TAG,
} = tags;

dcpcApi.enhanceEndpoints({ addTagTypes: [DEVICES_INVALIDATE_TAG] });
const devicesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getDatasourceDevices: builder.query({
      query: (id) => ({
        url: `datasources/${id}/datasource-program-blocks`,
        method: 'GET',
      }),
      // eslint-disable-next-line no-use-before-define
      transformResponse: (datasourceProgramBlocks) => {
        const devices = [];
        datasourceProgramBlocks.forEach((datasourceProgramBlock) => {
          const {
            id,
            enabled,
            programBlock,
            qc,
            serialNumber,
            inventoryNum,
            dateArchivingUTC,
            dateCommissioningUTC,
            dateNextVerificationUTC,
            dateVerificationUTC,
            dateWriteoffActualUTC,
            dateWriteoffPlanUTC,
            status,
          } = datasourceProgramBlock;

          devices.push({
            id,
            enabled,
            qc,
            serialNumber,
            inventoryNum,
            dateVerificationUTC,
            dateNextVerificationUTC,
            dateArchivingUTC,
            dateCommissioningUTC,
            dateWriteoffActualUTC,
            dateWriteoffPlanUTC,
            name: programBlock?.deviceType?.fullName || '',
            deviceTypeId: programBlock?.deviceType?.id,
            manufacturer: programBlock?.deviceType?.manufacturer?.name || '',
            programBlockId: programBlock?.id,
            status,
          });
        });
        const transformedData = {
          devices,
        };
        return { transformedData };
      },
      providesTags: (id) => [DEVICES_INVALIDATE_TAG, { type: DATASOURECES_INVALIDATE_TAG, id }, DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG, DEVICE_TYPES_TAG],
    }),

    getDatasourceForms: builder.query({
      query: (id) => ({
        url: `datasources/${id}/forms`,
        method: 'GET',
      }),
      transformResponse: (forms) => {
        const programs = [];
        const tmp = new Set([]);

        forms.forEach((form) => {
          const {
            id,
            datasourceProgramBlocks,
            program: {
              id: programId, name, observationType, phenomenonType,
            },
          } = form;

          programs.push({
            id,
            name,
            observationType,
            phenomenonType,
            datasourceProgramBlocks: datasourceProgramBlocks.map((dpb) => ({ ...dpb, datasourceProgram: { id } })),
            programId,
          });

          tmp.add(JSON.stringify({
            observationTypeId: observationType.id,
            observationType: observationType.description,
            ...(phenomenonType ? { phenomenonType: phenomenonType.name, phenomenonTypeId: phenomenonType.id } : { phenomenonType: null }),
          }));
        });
        const test = [...tmp].map((types) => JSON.parse(types)).sort((a, b) => a.observationTypeId - b.observationTypeId);
        return {
          programs, programTypes: [...test],
        };
      },
      providesTags: [DEVICES_INVALIDATE_TAG,
        DATASOURCE_PROGRAM_TAG,
        CREATE_PROGRAM_BLOCK_TAG,
        DELETE_PROGRAM_BLOCK_TAG,
        DELETE_DATASOURCE_PROGRAM_TAG,
        CREATE_DATASOURCE_PROGRAM_TAG,
        CREATE_DATASOURCE_PROGRAM_BLOCK_TAG,
        DELETE_DATASOURCE_PROGRAM_BLOCK_TAG,
        DELETE_PROGRAM_TAG,
      ],
    }),

    getDevice: builder.query({
      query: (id) => ({
        url: `device/${id}`,
        method: 'GET',
      }),
      providesTags: ({ id }) => [{ type: DEVICES_INVALIDATE_TAG, id }, DATASOURECES_INVALIDATE_TAG],
    }),

    updateDevice: builder.mutation({
      query: (device) => ({
        url: `device${device.id ? `/${device.id}` : ''}`,
        method: device.id ? 'PUT' : 'POST',
        body: device,
      }),
      invalidatesTags: (_, __, { id }) => [{ type: DEVICES_INVALIDATE_TAG, id }, DATASOURECES_INVALIDATE_TAG],
    }),

    deleteDevice: builder.mutation({
      query: (id) => ({
        url: `device/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => [{ type: DEVICES_INVALIDATE_TAG, id }, DATASOURECES_INVALIDATE_TAG],
    }),

    getDevices: builder.query({
      query: (params) => ({
        url: '/stations/devices',
        params,
      }),
    }),

    getDevicesCVS: builder.query({
      query: (params) => ({
        url: '/stations/devices/csv',
        params,
      }),
    }),

  }),
});

export const {
  useGetDatasourceDevicesQuery,
  useGetDatasourceFormsQuery,
  useGetDeviceQuery,
  useLazyGetDeviceQuery,
  useUpdateDeviceMutation,
  useDeleteDeviceMutation,

  useLazyGetDevicesQuery,
  useLazyGetDevicesCVSQuery,
} = devicesApi;
